
import { addWorkTime } from '@/api/order';
import { getTypeList } from '@/api/workTime';
import { UserModule } from '@/store/modules/user';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';


@Component({
  name: 'WorkTimeDialog',
  components: { }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  worktimeItemVisibility!: any;
  @Prop({
    type: String,
    default: ''
  })
  companyId!: string;
  @Prop({
    type: Object,
    default: () => {}
  })
  orderDetail!: any;
   @Prop({
     type: Number,
     default: 1
   })
  enterType!: any;
  // 1 报修添加 2 添加订单 3 处理

  private formInformation:any={
    workTimeType: '',
    workTime: {
      hour:0,
      minute:0
    }
  }
  private workTimeTypeList: any = [];
  private minutesOptions:any=[]

  created() {
    this.getWorkTimeType(0, true);

    //
    for (var i = 0; i < 61; i++) {
      this.minutesOptions.push(i);
    }
  }
  // 获取工时类型类表
  private getWorkTimeType(pid: any, isSet0:any) {
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      // pid: pid,
      // name: '',
      // is_need_child: 0,
      page: 1,
      size: 9999
    };
    getTypeList(params)
      .then((res: any) => {
        if (res.data && res.data.list) {
          this.workTimeTypeList = res.data.list;
        } else {
          this.workTimeTypeList = [];
        }
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  private comfirmSelectFault() {
    switch (this.enterType) {
      case 1:
        this.$emit('comfirmHandle', this.formInformation);
        break;
      case 2:
        this.$emit('comfirmHandle', this.formInformation);
        break;
      case 3:
        this.addHandle(
          this.formInformation.workTimeType,
          this.formInformation.workTime
        );
        break;
    }
  }
  private addHandle(valp: any, val: any) {
    if (!valp) {
      this.showErrorMsg('请选择工时类型');
      return;
    }
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      type_id: valp.id,
      type_name: valp.name,
      hour: val.hour,
      minute: val.minute,
    };
    if (this.orderDetail.order) {
      params.order_id = this.orderDetail.order.id;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    addWorkTime(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.formInformation.workTimeType = '';
        this.formInformation.workTime = {hour:0, minute:0};
        this.$emit('comfirmHandle', false);
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 选中工时类型
  private selectFault(val: any) {
    if (val.id) {
      // this.formInformation.workTime = {};
    }
  }
  close() {
    this.formInformation.workTimeType = '';
    this.formInformation.workTime = {hour:0, minute:0};
    this.$emit('close', false);
  }
  // 搜索

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
